import {
  queryClientOptions,
  type PayPeriodSchema
} from '@libs/data-access/queries'
import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../types'
import type { FetchPayPeriodOptions } from '../payPeriod.api'
import { fetchPayPeriod } from '../payPeriod.api'
import { payPeriodsQueryKeys } from '../payPeriod.queryKeys'

export const useFetchPayPeriod = (
  request: FetchPayPeriodOptions,
  queryOptions?: UseAppQueryOptions<PayPeriodSchema>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: payPeriodsQueryKeys.one(request?.pathParams?.pay_period_id),
    queryFn: () => fetchPayPeriod(request),
    staleTime: queryClientOptions.time.DYNAMIC
  })
}
